<template>
  <div class="body_center_right_media">
    <div class="body_center_right_head">免责声明</div>
    <div class="body_center_right_content">
      <div class="body_center_right_content_msg">1、本站（网址：52hrtt.com）为用户提供信息存储空间等服务，用户保证对发布的内容享有著作权或已取得合法授权，不会侵犯任何第三方的合法权益。</div>
      <div class="body_center_right_content_msg">2、刊载的文章由平台用户所有权归属原作者，不代表同意原文章作者的观点和立场。</div>
      <div class="body_center_right_content_msg">3、因平台信息海量，无法杜绝所有侵权行为，如有侵权烦请联系我们（必赞科技有限公司 邮箱：j-navi@bizaia.com），以便及时删除。</div>
    </div>
  </div>
</template>

<script>
import "@/assets/css/right.css"
export default {
  components: {
  },
  data () {
    return{
      
    }
  },
  created () {
  },
  methods: {
    
  }
}
</script>
<style scoped>
</style>